import { FormattedDate } from 'components/misc/FormattedDate';
import { ReactNode } from 'react';
import { FormattedMessage } from 'react-intl';
import { CaseClosingCheckDto } from 'types/caseClosing';
import { dateStringToDateObject } from 'utils/parseDate';

export const EMPTY_VALUE = '–';

export function CaseSummarySection({ check }: { check: CaseClosingCheckDto }) {
    return (
        <dl className="text-body2 m-0 grid grid-cols-[auto_1fr] gap-x-6 gap-y-1">
            <SummaryRow labelId="case-closing-modal.summary.supervising-partner">
                {check.supervisingPartner?.name ?? EMPTY_VALUE}
            </SummaryRow>
            <SummaryRow labelId="case-closing-modal.summary.responsible-lawyer">
                {check.responsibleLawyer?.name ?? EMPTY_VALUE}
            </SummaryRow>
            <SummaryRow labelId="case-closing-modal.summary.opened-date">
                <SummaryDate value={check.openedDate} />
            </SummaryRow>
            <SummaryRow labelId="case-closing-modal.summary.last-activity">
                <SummaryDate value={check.lastActivityDate} />
            </SummaryRow>
        </dl>
    );
}

function SummaryRow({ labelId, children }: { labelId: string; children: ReactNode }) {
    return (
        <>
            <dt className="text-fg-secondary">
                <FormattedMessage id={labelId} />
            </dt>
            <dd className="text-fg m-0">{children}</dd>
        </>
    );
}

export function SummaryDate({ value }: { value: string | null }) {
    return <FormattedDate value={value ? dateStringToDateObject(value) : null} fallback={EMPTY_VALUE} />;
}
